// See https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
if (window.CSS && CSS.supports("color", "var(--primary)")) {
  var setRealViewportHeight = function () {
    document.documentElement.style.setProperty("--real-viewport-height", window.innerHeight + "px");
  }

  window.addEventListener("resize", setRealViewportHeight);
  setRealViewportHeight();
}
